import { render, staticRenderFns } from "./phone-number-verification-form.vue?vue&type=template&id=5614bd16&"
import script from "./phone-number-verification-form.vue?vue&type=script&lang=js&"
export * from "./phone-number-verification-form.vue?vue&type=script&lang=js&"
import style0 from "./phone-number-verification-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5614bd16')) {
      api.createRecord('5614bd16', component.options)
    } else {
      api.reload('5614bd16', component.options)
    }
    module.hot.accept("./phone-number-verification-form.vue?vue&type=template&id=5614bd16&", function () {
      api.rerender('5614bd16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/phone-number-verification-form.vue"
export default component.exports